const gridsBehaviourList = [
  {
    media: '@media (min-width: 320px) { ... }',
    columns: 'grid for design: 6 columns',
    image: '320px'
  },
  {
    media: '@media (min-width: 768px) { ... }',
    columns: 'grid for design: 6 columns',
    image: '768px'
  },
  {
    media: '@media (min-width: 1024px) { ... }',
    columns: 'grid for design: 12 columns',
    image: '1024px'
  },
  {
    media: '@media (min-width: 1366px) { ... }',
    columns: 'grid for design: 12 columns',
    image: '1366px'
  },
  {
    media: '@media (min-width: 1600px) { ... }',
    columns: 'grid for design: 12 columns',
    image: '1600px'
  },
  {
    media: '@media (min-width: 1920px) { ... }',
    columns: 'grid for design: 12 columns',
    image: '1920px'
  },
];

export default gridsBehaviourList;



// WEBPACK FOOTER //
// ./src/containers/foundations/Grids/constants/gridsBehaviourList.js